import { http } from "../client";
import { mapTimetableDetailObject, } from "../shared/program";
export var updateRulesetDetail = function (data) {
    var request = {
        id: data.id,
        title: data.title,
        rules: data.entries.map(function (entry) {
            if (entry.type === "track") {
                return {
                    source_playlist_id: null,
                    track_id: entry.trackId,
                    n_tracks: 0,
                    duration: 0,
                    play_order: entry.playOrder,
                };
            }
            return {
                source_playlist_id: entry.playlistId,
                track_id: null,
                n_tracks: entry.trackCount,
                duration: entry.duration,
                play_order: entry.playOrder,
            };
        }),
    };
    return http.api
        .put("timetable-programs/".concat(request.id), request)
        .then(function (response) { return response.data.data; })
        .then(mapTimetableDetailObject);
};
